<template>
<div>
  <setup />
</div>
</template>

<script>
  import Setup from '../components/Setup/Setup.vue'

  export default {
    name: 'Home',
  props:["template"],
    components: {
      Setup,
    },
  }
</script>
